module.exports = __webpack_public_path__ + "images/spin-instructor-3900911062cfcc5c42eeac9614d72be1.png";